function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.08,258.14a4,4,0,0,0,5.09-2.46l6.65-19.12a4,4,0,0,0-2.47-5.09,4,4,0,0,0-1.31-.22,4,4,0,0,0-3.78,2.68l-6.65,19.12A4,4,0,0,0,133.08,258.14Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.18,220.2,112,228.52a4,4,0,1,0,3.48,7.2l17.18-8.32a4,4,0,0,0-3.49-7.2Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.32,206l19.11,6.65a4,4,0,1,0,2.63-7.55L111,198.42a4.08,4.08,0,0,0-1.32-.23,4,4,0,0,0-1.31,7.78Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.79,136.31a4,4,0,0,0-5.64.44L228,152.15a4,4,0,1,0,6.08,5.19L247.24,142A4,4,0,0,0,246.79,136.31Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,173.07l19-1.51a4,4,0,0,0-.63-8l-19,1.51a4,4,0,0,0,.64,8Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92,193.9l-15.39-13.13a4,4,0,0,0-5.2,6.09L245.73,200a4,4,0,1,0,5.19-6.09Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.48,99.68a13.2,13.2,0,1,0-16.59-8.55A13.21,13.21,0,0,0,153.48,99.68Zm-5.6-17.53a5.2,5.2,0,1,1-3.37,6.54A5.2,5.2,0,0,1,147.88,82.15Zm15-51.41A20.31,20.31,0,1,0,188.42,43.9,20.34,20.34,0,0,0,162.88,30.74Zm9.94,31.07a12.31,12.31,0,1,1,8-15.48A12.33,12.33,0,0,1,172.82,61.81Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,272.19h-33.9a4,4,0,0,0,0,8H209a4,4,0,0,0,0-8Z",
    style: {
      fill: "#2ba6de"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.06,203.28a4,4,0,0,1-3.69-2.47c-13.5-32.73-27.58-66.87-31.76-77-3.78-9.16-14.09-6.08-15.25-5.7a4,4,0,0,1-2.55-7.59c6.36-2.15,19.82-2.78,25.2,10.23,3.76,9.1,15.53,37.65,27.68,67.12l3.18-9.4a4,4,0,0,1,6.74-1.42l7.95,8.7,2.09-9.19a4,4,0,0,1,5.93-2.56l17.21,10.08,5.47-7.22c-11-26.61-27.63-66.76-31-74.82-5.38-13,4.6-22.07,10.62-25a4,4,0,0,1,3.54,7.18c-1.08.54-10.55,5.64-6.76,14.8,3.42,8.29,20.85,50.4,31.84,76.94a4,4,0,0,1-.51,3.95l-9,11.88a4,4,0,0,1-5.21,1l-15.57-9.12L186.67,195a4,4,0,0,1-6.86,1.81l-8.53-9.33-4.43,13.09a4,4,0,0,1-3.66,2.72Z",
    style: {
      fill: "#9c9fa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,342.22h-1.09a3.55,3.55,0,0,1-.46,0c-23.77-1.1-31.35-21.11-32-31.75,0-.1,0-.2,0-.3s.5-35.4,1-73.59a4,4,0,0,1,4-3.95h.06a4,4,0,0,1,3.94,4.06c-.49,36.61-1,70.66-1,73.41.18,2.07,2.55,23.56,25.14,24.16,23.11,0,24.08-21.52,24.11-22.44l1.11-93.65a4,4,0,0,1,4-4h.05a4,4,0,0,1,4,4.05L224.06,312c0,.38-1.32,29.71-31.29,30.25Z",
    style: {
      fill: "#9c9fa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75,243.92a4,4,0,0,1-3.22-1.63L171,232.06l-3.65,6.49a4,4,0,1,1-7-3.92L167,222.74a4,4,0,0,1,6.71-.41l7,9.55,5.61-13.34a4,4,0,0,1,6.45-1.34l12.22,11.74,13.26-13.49a4,4,0,1,1,5.7,5.61l-16,16.31a4,4,0,0,1-5.62.08L191.51,227l-6.07,14.46a4,4,0,0,1-3.21,2.42A3.87,3.87,0,0,1,181.75,243.92Z",
    style: {
      fill: "#9c9fa3"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e1c36ec261ba87ae104fbe53b1780696.svg";
export { ForwardRef as ReactComponent };